import { computed, ref } from 'vue'

export type DarkState = {
    isDark: boolean
}

const darkState = ref<DarkState>({
    isDark: false,
})

export function useIsDark() {
    const toggleDarkMode = () => {
        console.log('toggleDarkMode', darkState.value.isDark)
        darkState.value.isDark = !darkState.value.isDark
    }

    const isDark = computed(() => darkState.value.isDark)

    return {
        toggleDarkMode,
        isDark,
    }
}